module.exports = __webpack_public_path__ + "img/partnership.0f06c1a3.png";